export default (app) => {
  const service = app.service('api/stages');

  // The stages service returns a job, so it should fire/share
  // the jobs service's after hooks to ensure the job is shaped correctly
  // and placed in state. We reuse the job's get after hook for this
  // after create hook.
  service.name = 'jobs';
  const afterHooks = app.service('api/jobs').__hooks.after.get;
  service.hooks({
    before: {
      update: []
    },
    after: {
      update: afterHooks
    }
  });
};
